import { render, staticRenderFns } from "./SignedDocs.vue?vue&type=template&id=38a90d06&scoped=true"
import script from "./SignedDocs.vue?vue&type=script&lang=js"
export * from "./SignedDocs.vue?vue&type=script&lang=js"
import style0 from "./SignedDocs.vue?vue&type=style&index=0&id=38a90d06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a90d06",
  null
  
)

export default component.exports